module.exports = __webpack_public_path__ + "img/zh.79b5ceda.png";